// Version tracking for frontend
export const APP_VERSION = {
  version: '1.0.2',
  buildDate: new Date().toISOString(),
  features: [
    'Filtros de costos y estado de productos',
    'Botón de limpiar caché',
    'Sincronización de colecciones con nombres',
    'Firestore caching para productos',
  ],
  lastUpdate: '2025-12-06T18:00:00Z',
}

export function logVersion() {
  console.log('='.repeat(50))
  console.log('NIBPR Sales Insights - Frontend Version')
  console.log('='.repeat(50))
  console.log(`Version: ${APP_VERSION.version}`)
  console.log(`Build Date: ${APP_VERSION.buildDate}`)
  console.log(`Last Update: ${APP_VERSION.lastUpdate}`)
  console.log('Features:')
  APP_VERSION.features.forEach((feature, index) => {
    console.log(`  ${index + 1}. ${feature}`)
  })
  console.log('='.repeat(50))
}
